import {
  AfterContentInit,
  Component,
  ContentChild,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { LogoConfig, NavigationService } from '../../core/navigation/navigation.service';
import { Subscription } from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'lib-unauthenticated-layout',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './unauthenticated-layout.component.html',
  styleUrl: './unauthenticated-layout.component.css',
  standalone: true,
})
export class UnauthenticatedLayoutComponent implements OnInit, OnDestroy, AfterContentInit {
  private navigationService = inject(NavigationService);
  private sanitizer = inject(DomSanitizer);

  @Input() logo: LogoConfig = {
    type: 'image',
    src: 'assets/logo.png',
    alt: 'Logo',
  };

  @Input() backgroundImageUrl?: string;
  @Input() title?: string;

  @ContentChild('title') titleTemplate?: TemplateRef<string>;
  sanitizedSvgContent: SafeHtml = '';
  private hasTitle = false;
  private subscriptions: Subscription[] = [];

  constructor() {
    this.logo = this.navigationService.logo;
  }

  ngOnInit() {
    this.navigationService.backgroundChanges.subscribe((url) => {
      this.backgroundImageUrl = url;
    });

    const logoSub = this.navigationService.logoChanges.subscribe((logo) => {
      this.logo = logo;
    });
    this.subscriptions.push(logoSub);
    this.sanitizeSvgContent();
  }

  ngAfterContentInit() {
    this.hasTitle = !!this.titleTemplate;
  }

  hasContent(slotName: string): boolean {
    if (slotName === 'title') {
      return this.hasTitle;
    }
    return false;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  private sanitizeSvgContent() {
    if (this.logo.type === 'svg' && this.logo.svgContent) {
      this.sanitizedSvgContent = this.sanitizer.bypassSecurityTrustHtml(this.logo.svgContent);
    }
  }
}
